module.exports = __webpack_public_path__ + "static/media/timer_font.516e9bf7.ico";